// src/pages/admin/CreateRolePage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';

// Import components
import RoleForm from '../../components/roles/RoleForm';
import PageHeader from '../../components/ui/PageHeader';

// Import stores
import useRoleStore from '../../stores/roleStore';
import useNotificationStore from '../../stores/notificationStore';

/**
 * Page for creating a new role
 */
const CreateRolePage = () => {
  const navigate = useNavigate();
  const { createRole } = useRoleStore();
  const { showSuccess, showError } = useNotificationStore();
  
  // Handle form submission
  const handleSubmit = async (roleData) => {
    try {
      const newRole = await createRole(roleData);
      showSuccess('Role created successfully');
      navigate(`/admin/roles/${newRole.id}`);
    } catch (err) {
      showError(err.message || 'Failed to create role');
      throw err;
    }
  };
  
  // Handle form cancellation
  const handleCancel = () => {
    navigate('/admin/roles');
  };
  
  return (
    <Box>
      <PageHeader
        title="Create Role"
        subtitle="Define a new role with specific permissions"
        icon="security"
        backTo="/admin/roles"
      />
      
      <Box sx={{ mt: 3 }}>
        <RoleForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      </Box>
    </Box>
  );
};

export default CreateRolePage;